module.exports = __webpack_public_path__ + "img/job-status.eb0e2843.svg";